var keyMirror = require('./../../lib/keyMirror');

module.exports = keyMirror({
    RIGHT_BOTTOM: null,
    CENTER: null
});
